import { type IAnswerBase } from "../../../../Common/models";
import { type Answer, AssessmentAnswerType, AssessmentQuestionType } from "../../../types/state";

const defaultAnswerData = ((): { [key in AssessmentAnswerType]: () => IAnswerBase } => {
  const singleTextAnswer = (): IAnswerBase<Answer> => ({
    answer: { text: "", isCorrect: false },
    answerType: AssessmentAnswerType.SingleText,
    answerOrder: undefined,
  });

  const multipleTextAnswer = (): IAnswerBase<Answer> => ({
    answer: { text: "", isCorrect: false },
    answerType: AssessmentAnswerType.MultipleText,
    answerOrder: undefined,
  });

  return {
    [AssessmentAnswerType.SingleText]: singleTextAnswer,
    [AssessmentAnswerType.MultipleText]: multipleTextAnswer,
  };
})();

export const getAnswerDefaultData = (questionType: number): IAnswerBase => {
  const questionTypeToAnswerType = {
    [AssessmentQuestionType.SingleChoiceTextQuestion]: AssessmentAnswerType.SingleText,
    [AssessmentQuestionType.MultipleChoiceTextQuestion]: AssessmentAnswerType.MultipleText,
  };
  return defaultAnswerData[questionTypeToAnswerType[questionType as AssessmentQuestionType]]();
};
